if(!customElements.get('custom-tabs-handler')) {
  customElements.define('custom-tabs-handler', class CustomTabsHandler extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.onChangeHandler = this.onChange.bind(this);
      this.addEventListener('change', this.onChangeHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('change', this.onChangeHandler);
    }

    onChange(e) {
      window.dispatchEvent(new Event('scroll'));
    }
  });
};

/* ==========================================================================
   E-Mobility — se QUITO el ajuste que igualaba la altura de las pestañas.

   Antes se medía el panel más alto y se fijaba esa altura en el contenedor,
   para que la sección no saltara al cambiar de pestaña. El efecto secundario
   era peor que el problema: "Descripción" -que es la que ve el 100% de los
   visitantes al entrar- quedaba con cientos de píxeles en blanco debajo,
   heredados de la pestaña más larga.

   Ahora cada pestaña ocupa su propio alto. El salto al cambiar solo lo nota
   quien cambia de pestaña; el espacio muerto lo veía todo el mundo.
   ========================================================================== */
